import React from 'react'
import ReactPlayer from 'react-player'

export default function VideoPlayer({ url, className='', muted = true, ...props }) {
  return (
    <ReactPlayer className={className} playsinline={true} width='100%' height='100%' playing={true} url={url} loop={true} autoPlay={true} muted={muted} {...props} />
  )
}
